import './TitleSection.css';
import React from 'react';

function TitleSection({ title, span }) {
  return (
    <div className='titleSection'>
      <div className="container">
        <div className="row marginsection">
          <h2>{title}
            <span>{span}</span>
            </h2>
        </div>
      </div>
    </div>
  );
}

export default TitleSection;
